import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../store/auth";

export const PublicRouterOutlet = () => {
  const { user } = useAuthStore.getState();

  return user ? <Navigate to={"/home"} /> : <Outlet />;
};
